// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__2kk3D"};